import { projectUserRoles } from '@/Models';

export const permissionLevelTypes = {
    creatorOnly: 'creator',
    projectOnly: 'project',
    globalOnly: 'global',
    all: 'all',
};

// Used to check in backer side if user has permission to project
export function userHasProjectPermission(user, permission, creatorID, projectID) {
    if (user) {
        if (user.globalPermissions.includes(permission))
            return true;

        if (creatorID && user.creatorPermissions[creatorID]?.includes(permission))
            return true;

        if (projectID && user.projectPermissions[projectID]?.includes(permission))
            return true;
    }

    return false;
}

// Used to check in admin side if user has permission to project
export function hasAdminPermission(user, permission, projectContext, level = permissionLevelTypes.all) {
    if (!user) {
        return false;
    }

    if (user.globalPermissions?.includes(permission)) {
        return true;
    }

    if (level === permissionLevelTypes.globalOnly) {
        return false;
    }

    if ((level === permissionLevelTypes.creatorOnly || level === permissionLevelTypes.all)
        && projectContext?.creator?.permissions?.includes(permission)) {
        return true;
    }

    return !!((level === permissionLevelTypes.projectOnly || level === permissionLevelTypes.all)
        && projectContext?.project?.permissions?.includes(permission));
}

export function userHasSystemPermission(user, permission) {
    if (user) {
        return user.systemPermissions.includes(permission);
    }

    return false;
}

export function getAvailableProjectUserRolesForProject() {
    return Object.values(projectUserRoles)
        .filter(r => r.displayName);
}

export const hasProjectPermissionCurried = (user, projectContext, level = permissionLevelTypes.all) => permission => hasAdminPermission(
    user,
    permission,
    projectContext,
    level,
);
